import { useSearch } from "@tanstack/react-router";
import { useMemo } from "react";

import Checkbox from "@/components/checkbox";
import type { ExploreSearchParams } from "@/routes/explore/index";

interface CheckboxFilterProps {
  label?: React.ReactNode;
  name?: string;
  options: string[] | string[][] | [string, React.ReactNode][];
}

export default function CheckboxFilter({
  label,
  name,
  options,
}: CheckboxFilterProps) {
  const search = useSearch({ strict: false }) as ExploreSearchParams;

  const checkedValues = useMemo((): string[] => {
    if (!name) {
      return [];
    }
    const value = search[name as keyof ExploreSearchParams];
    if (!value) {
      return [];
    }
    if (typeof value === "string") {
      return value.split(",");
    }
    return [String(value)];
  }, [search, name]);

  return (
    <>
      {!!label && (
        <h4 className="mb-5 font-medium text-16 leading-[1.5em] md:mb-2.5 md:leading-[1.2em]">
          {label}
        </h4>
      )}
      <div className="flex flex-col items-stretch gap-5 md:gap-2.5">
        {options.map((option) => {
          const [key, value] =
            typeof option === "string" ? [option, option] : option;

          return (
            <Checkbox
              className="relative"
              defaultChecked={checkedValues.includes(key)}
              key={key}
              name={name}
              value={key}
            >
              {value}
            </Checkbox>
          );
        })}
      </div>
    </>
  );
}
